import { useState } from "react";
import MuiAccordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import AddCircleIcon from "@mui/icons-material/AddCircle";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import "./Accordion.scss";
import { Trans } from "react-i18next";
interface AccordionProps {
  content: {
    question: string;
    answer: string;
  }[];
}

interface Expanded {
  [key: string]: boolean;
}

function Accordion({ content }: AccordionProps) {
  const [expanded, setExpanded] = useState<Expanded>({});

  const handleChange = (panel: string) => () => {
    setExpanded((prev) => ({
      ...prev,
      [panel]: !prev[panel],
    }));
  };
  return (
    <div className="accordion-container">
      {content.map((item, index) => {
        return (
          <MuiAccordion
            key={index}
            expanded={Boolean(expanded[`panel${index}`])}
            onChange={handleChange(`panel${index}`)}
          >
            <AccordionSummary
              expandIcon={
                expanded[`panel${index}`] ? (
                  <RemoveCircleIcon />
                ) : (
                  <AddCircleIcon />
                )
              }
              aria-controls={`panel${index}-content`}
              id={`panel${index}-header`}
            >
              <Typography component="span">
                {item.question === "question4" ? (
                  <div className="question">
                    <Trans
                      i18nKey="FAQ.business.question4"
                      components={{
                        KYB: <a href="/KYB.pdf" target="_blank" />,
                      }}
                    />
                  </div>
                ) : (
                  <div className="question">{item.question}</div>
                )}
              </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography>{item.answer}</Typography>
            </AccordionDetails>
          </MuiAccordion>
        );
      })}
    </div>
  );
}
export default Accordion;
